import { render, staticRenderFns } from "./Skokie.vue?vue&type=template&id=c2e20e24&scoped=true&"
import script from "./Skokie.vue?vue&type=script&lang=js&"
export * from "./Skokie.vue?vue&type=script&lang=js&"
import style0 from "./Skokie.vue?vue&type=style&index=0&id=c2e20e24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2e20e24",
  null
  
)

export default component.exports